import { Box } from "@bca/ui-library";
import styled from "styled-components";
import { grid, GridProps } from "styled-system";

import { Devices, DeviceTypes } from "../Hooks/useViewport.hook";
import VehicleCardMobile from "../VehicleCard/VehicleCardMobile";
import VehicleGridLoader from "./VehicleGridLoader";

const GridContainer = styled(Box)<GridProps>`
  & > li {
    display: flex;
    flex-direction: column;
    list-style-type: none;
  }
  ${grid}
`;

export interface VehicleGridProps {
  vehicles: any;
  viewportWidth?: DeviceTypes;
  isLoading?: Boolean;
  degradedServices: string[];
  setGetOpenBankingLinkError: (shouldShowBanner: boolean) => void;
}

const VehicleGrid: React.FunctionComponent<VehicleGridProps> = ({
  vehicles,
  viewportWidth = Devices.DESKTOP,
  isLoading = false,
  degradedServices,
  setGetOpenBankingLinkError,
}) => {
  const shouldShowVehicles = !isLoading && vehicles.length > 0;
  return (
    <GridContainer
      display="grid"
      as="ul"
      gridTemplateColumns={{
        mobile: "1fr",
        tablet: "repeat(auto-fill, minmax(288px, 1fr))",
        desktop: "repeat(auto-fill, 315px)",
      }}
      css={`
        grid-gap: 20px;
        justify-content: center;
        padding: 0;
      `}
      marginTop={16}
    >
      {isLoading && <VehicleGridLoader viewportWidth={viewportWidth} />}
      {shouldShowVehicles &&
        vehicles.map((vehicle) => {
          return (
            <VehicleCardMobile
              key={vehicle.vrm}
              vehicle={vehicle}
              degradedServices={degradedServices}
              setGetOpenBankingLinkError={setGetOpenBankingLinkError}
            />
          );
        })}
    </GridContainer>
  );
};

export default VehicleGrid;
